import { ReactNode } from 'react';

import { relForUrl } from '../../helpers/links';
import { GlossaryLink } from '../Glossary/GlossaryLink';

interface Props {
  href: string;
  linktype: string;
  target: string | null;
}

export const RichTextLink = (
  children: ReactNode,
  { href, linktype, target }: Props,
) => {
  if (linktype === 'glossary') {
    return <GlossaryLink href={href}>{children}</GlossaryLink>;
  }

  return (
    <a
      href={linktype === 'email' ? `mailto:${href}` : href}
      rel={relForUrl(href)}
      target={target || undefined}
    >
      {children}
    </a>
  );
};
